export class PerfilBusqueda {
  public actividadVulnerableId: number = -1;
  public claveActividadVulnerable: string = "";
  public sujetoObligadoId: number = -1;
  public claveSujetoObligado: string = "";
  public rolId: number = -1;
  public almacen: any[] = [];
  public actividadesVulnerables: any[] = [];
}
